const annotationConstants = {
	FETCH_ANNOTATION_PRODUCTS_SUCCESS: 'FETCH_ANNOTATION_PRODUCTS_SUCCESS',
	FETCH_ANNOTATION_CONTAINERS_SUCCESS: 'FETCH_ANNOTATION_CONTAINERS_SUCCESS',
	FETCH_QMS_ANNOTATION_SUCCESS: 'FETCH_QMS_ANNOTATION_SUCCESS',
	FETCH_TEMP_ANNOTATION_SUCCESS: 'FETCH_TEMP_ANNOTATION_SUCCESS',
	FETCH_IMS_ANNOTATION_SUCCESS: 'FETCH_IMS_ANNOTATION_SUCCESS',
};

export default annotationConstants;
